import { PayloadAction } from '@reduxjs/toolkit';
import { SessionStreamingOptions } from '@/types/session.types';
import { ProjectStateReducerCreator } from '../types';

const setStreamingOptionOnAllSessions = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<Partial<SessionStreamingOptions>>) => {
    if (!state.workingProject) return;
    state.workingProject.sessions = state.workingProject.sessions.map((session) => {
      return {
        ...session,
        streaming_options: {
          ...session.streaming_options,
          ...action.payload,
        },
      };
    });
    state.sessionsToUpdateAfterProjectSave = state.workingProject.sessions;
  });
};

export default setStreamingOptionOnAllSessions;
